// src/router/index.js
// Vue Router 4 不再导出 Router 构造函数，而是导出 createRouter/createWebHistory
import { createRouter, createWebHistory } from 'vue-router'
// 导入组件
import BackpackInfo from '../components/BackpackInfo.vue'
import GameStatsPanel from '../components/GameStatsPanel.vue'
import Dashboard from '../components/Dashboard.vue'

// 定义路由规则
const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/backpack',
    name: 'BackpackInfo',
    component: BackpackInfo
  },
  {
    path: '/stats',
    name: 'GameStatsPanel',
    component: GameStatsPanel
  }
]

// 创建路由实例（Vue Router 4 的正确方式）
const router = createRouter({
  history: createWebHistory(), // 替代 Vue2 的 mode: 'history'
  routes
})

export default router